module.exports = __webpack_public_path__ + "img/13_Middle Descending Colon(and Descending colon).4b7bef85.png";